import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { black, white } from '../../../styles/colors';
import { LaunchpadButton, WhiteLaunchpadButton } from '../../../styles/LaunchpadButton';

const ModalBackdrop = styled.div({
  position: 'fixed',
  top: '0',
  bottom: '0',
  left: '0',
  right: '0',
  backgroundColor: 'rgba(0,0,0,.7)',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'stretch'
});

const Slider = styled.div({
  width: '500px',
  display: 'block'
});

const DialogBox = styled.div((props) => {
  let style = {
    position: 'relative',
    backgroundColor: white,
    // height: '243px',
    width: '500px',
    paddingTop: '50px',
    paddingRight: '60px',
    paddingBottom: '50px',
    paddingLeft: '60px',
    textAlign: 'center',
    transition: 'top 0.6s',
    top: '-100%'
  };
  if (props.hasDroppedIn) {
    style.top = '25%';
  }
  return style;
});

const Header = styled.div({
  color: black,
  fontSize: '20px',
  fontWeight: '200',
  letterSpacing: '1px'
});

const Body = styled.div({
  color: black,
  display: 'block',
  fontSize: '14px',
  fontWeight: '300',
  maxHeight: '100px',
  minHeight: '60px',
  lineHeight: '18px',
  overflowY: 'auto',
  textAlign: 'left',
  marginTop: '8px',
  marginBottom: '16px',
  width: '100%'
});

const ButtonRow = styled.div({
  marginTop: '10px',
  textAlign: 'center'
});

const OKButton = styled(LaunchpadButton)({
  display: 'inline-flex',
  width: '150px',
  marginRight: '26px'
});

const CancelButton = styled(WhiteLaunchpadButton)({
  display: 'inline-flex',
  width: '150px'
});

//*********************************************
export class ModalDialog extends PureComponent {
  componentWillMount = () => {
    this.setState({
      hasDroppedIn: false
    });
  };

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({ hasDroppedIn: true });
    }, 100);
  };

  render = () => {
    return (
      <ModalBackdrop>
        <Slider>
          <DialogBox data-qa="ModalBox" hasDroppedIn={this.state.hasDroppedIn}>
            <Header>{this.props.headerText}</Header>
            <Body>{this.props.bodyText}</Body>
            <ButtonRow>
              <OKButton onClick={this.props.okButtonClickHandler}>{this.props.okButtonText}</OKButton>
              <CancelButton onClick={this.props.cancelButtonClickHandler}>{this.props.cancelButtonText}</CancelButton>
            </ButtonRow>
          </DialogBox>
        </Slider>
      </ModalBackdrop>
    );
  };
}

ModalDialog.propTypes = {
  headerText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  okButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
  okButtonClickHandler: PropTypes.func.isRequired,
  cancelButtonClickHandler: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownprops) => ({});
const propActions = {};
export const ModalDialogContainer = connect(
  mapStateToProps,
  propActions
)(ModalDialog);



// WEBPACK FOOTER //
// ./src/modules/app/util/ModalDialog.jsx